<template>
    <div class="mx-auto py-10 pb-20 lg:pt-10 lg:pb-20 lg:flex lg:items-center">
        <div class="lg:w-0 lg:flex-1 text-center sm:text-left">
            <h2 :style="{ color: footer.fontColor }" class="text-3xl font-extrabold sm:text-4xl">
                <cUtilsEdit @edit="goToContentField('footerNewsletterText1')">
                    <span>{{ footer.newsletterText1 }}</span>
                </cUtilsEdit>
                <cUtilsEdit @edit="goToContentField('footerNewsletterText2')">
                    <span :style="{ color: footer.mainColor }">{{ footer.newsletterText2 }}</span>
                </cUtilsEdit>
            </h2>
            <div class="mt-3 max-w-3xl">
                <cUtilsEdit @edit="goToContentField('footerNewsletterText3')">
                    <p :style="{ color: footer.fontColor }" class="text-lg">
                        {{ footer.newsletterText3 }}
                    </p>
                </cUtilsEdit>
            </div>
        </div>
        <div class="mt-8 lg:mt-0 lg:ml-8">
            <form
                class="sm:flex"
                :action="footer.newsletterUrl"
                method="post"
                target="_blank"
                @submit="goToFormSubmit"
            >
                <label for="email-address" class="sr-only">{{ $t("shared.email") }}</label>
                <input
                    id="email-address"
                    name="email-address"
                    type="email"
                    autocomplete="email"
                    required=""
                    :style="{
                        color: footer.fontColor,
                        'border-color': footer.borderColor,
                    }"
                    class="w-full px-5 py-3 border shadow-sm placeholder-gray-400 focus:ring-0 sm:max-w-xs rounded-md hover:opacity-100 bg-transparent"
                    :placeholder="$t('shared.email')"
                />
                <div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                    <button
                        type="submit"
                        :style="{ 'background-color': footer.mainColor }"
                        class="w-full flex items-center justify-center py-3 px-5 border border-transparent text-base font-medium rounded-md text-white opacity-90"
                        :disabled="!footer.newsletterUrl"
                    >
                        <cUtilsEdit @edit="goToContentField('footerNewsletterCta')">
                            <span>{{ footer.newsletterCta }}</span>
                        </cUtilsEdit>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { useLegalGoTo } from "@/views/tools/legal/utils/useLegalGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "cNewsletter",
    setup() {
        const { goToFormSubmit, goToContentField } = useLegalGoTo();
        return {
            goToFormSubmit,
            goToContentField,
        };
    },
    components: { cUtilsEdit },
    props: {
        footer: Object,
    },
};
</script>
